import { render, staticRenderFns } from "./AllocationSupplierDialog.vue?vue&type=template&id=18732cea&scoped=true"
import script from "./AllocationSupplierDialog.vue?vue&type=script&lang=js"
export * from "./AllocationSupplierDialog.vue?vue&type=script&lang=js"
import style0 from "./AllocationSupplierDialog.vue?vue&type=style&index=0&id=18732cea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18732cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18732cea')) {
      api.createRecord('18732cea', component.options)
    } else {
      api.reload('18732cea', component.options)
    }
    module.hot.accept("./AllocationSupplierDialog.vue?vue&type=template&id=18732cea&scoped=true", function () {
      api.rerender('18732cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/AllocationSupplierDialog.vue"
export default component.exports